import React, { Fragment, useState, useEffect, useMemo, useRef } from "react";
import ElsaDialog from "./ElsaDialog";
import { ReactComponent as ElsaLogo } from "../pages/ElsaLogov2.svg";

const ElsaContent = React.memo(({ content, children }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [hasAnimated, setHasAnimated] = useState(false);

  useEffect(() => {
    if (!hasAnimated) {
      setTimeout(() => {
        setIsVisible(true);
        setHasAnimated(true);
      }, 500);
    }
  }, [hasAnimated]);

  return (
    <>
      <div
        style={{
          transition: "all 300ms ease-out",
          transform: isVisible ? "translateY(0)" : "translateY(20px)",
          opacity: isVisible ? 1 : 0,
        }}
      >
        <ElsaDialog content={content} />
      </div>
      <div
        style={{
          transition: "all 300ms ease-out",
          transform: isVisible ? "translateY(0)" : "translateY(20px)",
          opacity: isVisible ? 1 : 0,
        }}
      >
        <ElsaLogo className="w-5 h-5" />
      </div>
      {children && React.cloneElement(children, { isVisible })}
    </>
  );
});

export default ElsaContent;
